import { styled } from 'styled-components';

export const Title = styled.span`
  font-size: 20px;
  font-family: 'Poppins-Medium';
  text-align: center;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: 100vh;
  background-color: #faf5f6;
  align-items: center;
  justify-content: center;
`;
export const Content = styled.div`
  padding: 24px;
  background-color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 40px;
`;
